import React from "react";

/**
 * Marquee — one slow, editorial ticker between the hero and the metrics
 * section. A dark ink strip carrying the brand message in alternating
 * serif-italic / overline voices. Pure CSS animation (60s loop), pauses
 * on hover and disables itself for reduced-motion users.
 */

const ITEMS = [
  { text: "Lidera con Voz Propia", serif: true },
  { text: "Edición Primer Aniversario", serif: false },
  { text: "Sevilla — 15 de octubre", serif: true },
  { text: "Liderazgo · Comunicación · Estrategia", serif: false },
  { text: "Un espacio para mujeres que lideran con criterio", serif: true },
  { text: "Aforo limitado", serif: false },
];

const Track = ({ hidden = false }) => (
  <div
    className="flex shrink-0 items-center gap-10 md:gap-16 pr-10 md:pr-16"
    aria-hidden={hidden || undefined}
  >
    {ITEMS.map((item, i) => (
      <React.Fragment key={i}>
        <span
          className={
            item.serif
              ? "font-serif italic text-2xl md:text-4xl leading-none whitespace-nowrap"
              : "overline whitespace-nowrap text-[#F4EFE7]/70"
          }
        >
          {item.text}
        </span>
        <span className="h-px w-8 md:w-12 bg-[#F4EFE7]/35 shrink-0" aria-hidden />
      </React.Fragment>
    ))}
  </div>
);

const Marquee = () => (
  <div
    className="marquee overflow-hidden bg-[#3F403A] text-[#F4EFE7] py-5 md:py-7"
    data-testid="editorial-marquee"
  >
    <div className="marquee-track flex w-max">
      <Track />
      <Track hidden />
    </div>
  </div>
);

export default Marquee;
